import { Backspace, MagnifyingGlass } from 'phosphor-react'
import { useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'

import styles from './styles.module.css'

const SearchInput = ({
  data = [],
  showOptions,
  setValue,
  searchValue = '',
  handleClear = () => {},
  handleSearch,
  placeholder,
  edit = true,
  md = 7,
}) => {
  const [search, setSearch] = useState('')
  const [modified, setModified] = useState(false)
  return (
    <Col
      md={md}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      {!modified && edit && data?.length === 1 && showOptions ? (
        <>
          <div>
            <Form.Select
              className={styles.searchInput}
              onChange={(event) => {
                setValue(Number(event.target.value))
                setModified(true)
              }}
            >
              <option value={data[0].id}>{data[0].name}</option>
            </Form.Select>
          </div>
          <Button className={styles.rightBtn} onClick={handleClear}>
            <Backspace size={20} />
          </Button>
        </>
      ) : (
        <>
          {showOptions && data?.length ? (
            <>
              <Form.Select
                className={styles.searchInput}
                onChange={(event) => setValue(Number(event.target.value))}
              >
                <option value="0">Selecione uma opção</option>
                {data?.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.name}
                  </option>
                ))}
              </Form.Select>

              <Button className={styles.rightBtn} onClick={handleClear}>
                <Backspace size={20} />
              </Button>
            </>
          ) : (
            <>
              <Form.Control
                className={styles.searchInput}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault()
                    handleSearch(search)
                  }
                }}
                placeholder={placeholder}
                value={searchValue || search}
                onChange={(event) => [setSearch(event.target.value), setValue(event.target.value)]}
              />
              <Button
                className={styles.rightBtn}
                onClick={(event) => {
                  event.preventDefault()
                  handleSearch(search)
                }}
                type="submit"
              >
                <MagnifyingGlass size={20} />
              </Button>
            </>
          )}
        </>
      )}
    </Col>
  )
}

export default SearchInput
